import { viewMore } from 'Components/UI/Accounts/AccountManagement/TableActions';
import uploadImageAction from 'Components/UI/Meta/MetaTable/actions/uploadCuratedContentArticleImage';
import deleteAction from './delete';
import toggleHideAction from './toggleHide';

const actions = {
  delete: deleteAction,
  toggleHide: toggleHideAction,
  viewMore,
  uploadImageAction,
};

export default actions;
